<ziro-text [fieldId]="'name'"></ziro-text>
<ziro-select [fieldId]="'cucmServer'"></ziro-select>
<ziro-select [fieldId]="'impServer'"></ziro-select>
<ziro-select [fieldId]="'pcceServer'"></ziro-select>
